import { defOp } from "./internal/codegen";
export const [invert, invert2, invert3, invert4] = defOp(([o, a]) => `${o}=1/${a};`);
